import { useI18n } from '@/i18n';

export function GuestCounter({ guestCounts, maxGuests, onUpdateGuestCount }) {
  const { t } = useI18n();

  const rows = [
    { type: 'adults', label: t('detail.adults') || 'Adultos', sub: t('detail.age13plus') || '13 años o más', min: 1 },
    { type: 'children', label: t('detail.children') || 'Niños', sub: t('detail.age2to12') || '2 a 12 años', min: 0 },
    { type: 'infants', label: t('detail.infants') || 'Bebés', sub: t('detail.under2') || 'Menos de 2 años', min: 0 },
  ];

  return (
    <div className="mb-6" data-testid="guest-counter-section">
      <label className="block text-sm font-medium text-[#1C1917] mb-3">
        {t('detail.guests') || 'Huéspedes'}
      </label>
      <div className="border border-[#E7E5E4] rounded-lg divide-y divide-[#E7E5E4]">
        {rows.map(({ type, label, sub, min }) => (
          <div key={type} className="flex items-center justify-between px-4 py-3">
            <div>
              <p className="text-sm font-medium text-[#1C1917]">{label}</p>
              <p className="text-xs text-[#78716C]">{sub}</p>
            </div>
            <div className="flex items-center gap-3">
              <button
                onClick={() => onUpdateGuestCount(type, -1)}
                disabled={guestCounts[type] <= min}
                className="w-8 h-8 rounded-full border border-[#E7E5E4] flex items-center justify-center text-[#57534E] hover:border-[#264639] disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                data-testid={`${type}-minus`}
              >−</button>
              <span className="w-6 text-center font-medium text-[#1C1917]" data-testid={`${type}-count`}>{guestCounts[type]}</span>
              <button
                onClick={() => onUpdateGuestCount(type, 1)}
                disabled={type === 'infants' ? guestCounts.infants >= 5 : guestCounts.adults + guestCounts.children >= maxGuests}
                className="w-8 h-8 rounded-full border border-[#E7E5E4] flex items-center justify-center text-[#57534E] hover:border-[#264639] disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                data-testid={`${type}-plus`}
              >+</button>
            </div>
          </div>
        ))}
      </div>
      <p className="text-xs text-[#78716C] mt-2 px-1">
        {t('detail.maxGuests') || 'Máximo'}: {maxGuests} {t('detail.guestsLabel') || 'huéspedes'} ({t('detail.infantsNotCount') || 'los bebés no cuentan'})
      </p>
    </div>
  );
}
